module.exports = __webpack_public_path__ + "lu.6146b22f4b505ef8e2fe.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/lu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/lu.svg
// module chunks = styles